import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/empresa';
const EXTERNAL_BASE_ENDPOINT = '/ext/empresa';

const companyEndpoints = {
    getCompanyTypes: () => stipAxios.get(`${EXTERNAL_CONTEXT}/tipoempresa/find-all`),
    getCompanyTypesGeneral: () => stipAxios.get(`${EXTERNAL_CONTEXT}/tipoempresa/find-all-geral`),
    getPersonTypes: () => stipAxios.get(`${EXTERNAL_CONTEXT}/tipo-pessoa-fisica/find-all`),
    getIndustry: () => stipAxios.get(`${EXTERNAL_CONTEXT}/ramo-atividade/find`),
    getCompany: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/find`, payload),
    saveCompany: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/save`, payload),
    getCompanyDebitCertificates: (payload) =>
        stipAxios.post(`${BASE_ENDPOINT}/find/certidao-debitos`, payload, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/pdf',
            },
        }),
    getCompanyDae: (payload) => stipAxios.post(`${BASE_ENDPOINT}/find/dae`, payload),
    getCompanyFinancialPendencies: (payload) => stipAxios.post(`${BASE_ENDPOINT}/find/pendencias-financeiras`, payload),
    setSelectedCompany: (cdEmpresaSelecionada) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}/usuario/set${BASE_ENDPOINT}/${cdEmpresaSelecionada}`, {}),
    getLastChangesCompany: (cdEmpresa) => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/anterior/${cdEmpresa}`),
    buscaSolicitacaoEmAndamentoComVeiculoComplementar: (cdEmpresa) =>
        stipAxios.get(
            `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdEmpresa}/busca-solicitacao-andamento-veiculo-complementar`,
        ),
    buscaSolicitacaoInclusaoVeiculoComplementar: (cdEmpresa, params = {}) =>
        stipAxios.get(
            `${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdEmpresa}/busca-solicitacao-inclusao-veiculo-complementar`,
            params,
        ),
    possuiVeiculoComplementarAtivo: (cdEmpresa) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdEmpresa}/possui-veiculo-complementar-ativo`),
    getCompanies: ({ page, size, request = {} }) => {
        return stipAxios.post(`${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`, request);
    },
    getAdminCompanies: (cdEmpresa) => {
        return stipAxios.get(`${BASE_ENDPOINT}/admin/${cdEmpresa}`);
    },
    getCompaniesByUser: (cdUsuario) => {
        return stipAxios.get(`${BASE_ENDPOINT}/all-cdempresa-by-cdusuario/${cdUsuario}`);
    },
    getAllCompanies: () => {
        return stipAxios.get(`${BASE_ENDPOINT}/find-all`);
    },
    getAllStripCompanies: () => {
        return stipAxios.get(`${BASE_ENDPOINT}/find-all-strip`);
    },
    getAllCompaniesAndUsers: () => {
        return stipAxios.get(`${BASE_ENDPOINT}/find-all-with-users`);
    },
    bloquearCadastroVeiculosComplementares: (cdEmpresa, params = {}) =>
        stipAxios.post(`${EXTERNAL_BASE_ENDPOINT}/${cdEmpresa}/bloquearCadastroVeiculosComplementares`, params),
    subsistemasDisponiveisPara: (cdEmpresa) =>
        stipAxios.get(`${EXTERNAL_BASE_ENDPOINT}/${cdEmpresa}/subsistemasDisponiveis`),
};
export default companyEndpoints;
